import type { Schemas } from "./api"

/** The generated `GET /v1/why` contract (#3167). */
export type WhyResponse = Schemas["WhyResponse"]
export type WhyNode = Schemas["WhyNode"]
export type WhyEdge = Schemas["WhyEdge"]
export type WhyStep = Schemas["WhyStep"]

/** The icon/label group of a lineage node kind; `Technical(Mapping)` groups as Technical. */
export type WhyNodeGroup = "Fact" | "Commit" | "Decision" | "Observation" | "Trigger" | "SourceRecord" | "Object" | "Technical" | "Other"

const GROUPS: readonly WhyNodeGroup[] = ["Fact", "Commit", "Decision", "Observation", "Trigger", "SourceRecord", "Object"]

export function nodeGroup(kind: string): WhyNodeGroup {
  if ((GROUPS as readonly string[]).includes(kind)) return kind as WhyNodeGroup
  if (kind.startsWith("Technical")) return "Technical"
  return "Other"
}

/** Edges whose endpoints are both present, so the canvas never draws to a node it cannot show. */
export function connectedEdges(answer: Pick<WhyResponse, "nodes" | "edges">): WhyEdge[] {
  const ids = new Set(answer.nodes.map((n) => n.id))
  return answer.edges.filter((e) => ids.has(e.from) && ids.has(e.to))
}
